import { Helmet } from 'react-helmet-async';
import { motion } from 'framer-motion';
import { BASE_URL, OG_IMAGE } from '../utils/seo';
import { enterUp } from '../utils/animations';
import { SoloAgentsSection } from '../components/who-we-serve/SoloAgents';
import { TeamLeadersSection } from '../components/who-we-serve/TeamLeaders';
import { TeamVARoles } from '../components/who-we-serve/TeamVARoles';
import { IndustryGrid } from '../components/who-we-serve/IndustryGrid';
import { SharedPain } from '../components/who-we-serve/SharedPain';
import { PageCTA } from '../components/PageCTA';

export default function WhoWeServe() {
    return (
        <div data-testid="who-we-serve-page">
            <Helmet>
                <title>Who We Serve - White Glove Hiring</title>
                <meta name="description" content="White Glove Hiring works with solo agents, team leaders, and industry professionals. If your growth is limited by how much you personally can do, we built this for you." />
                <meta property="og:title" content="Who We Serve - White Glove Hiring" />
                <meta property="og:description" content="For solo agents doing everything themselves and team leaders still doing two jobs. The pain is the same." />
                <meta property="og:type" content="website" />
                <meta property="og:url" content={`${BASE_URL}/who-we-serve`} />
                <meta property="og:image" content={OG_IMAGE} />
                <link rel="canonical" href={`${BASE_URL}/who-we-serve`} />
            </Helmet>

            <section className="bg-navy-900 hero-pattern pt-36 pb-20">
                <div className="max-w-7xl mx-auto px-6 lg:px-12">
                    <motion.div {...enterUp}>
                        <p className="text-gold-400 text-xs font-bold tracking-[0.3em] uppercase font-inter mb-4">For Real Estate Agents & Industry Professionals</p>
                        <h1 className="font-montserrat font-black text-4xl md:text-5xl lg:text-6xl text-white tracking-tight leading-tight max-w-4xl">
                            You Didn't Get This Far by Doing Everything Wrong. But Something Has to Change.
                        </h1>
                        <p className="text-gray-300 text-lg mt-5 max-w-2xl leading-relaxed">
                            White Glove Hiring works with two types of operators. Both are successful. Both are overwhelmed. Both know they need leverage - and haven't found a version of it that actually works yet.
                        </p>
                    </motion.div>
                </div>
            </section>

            <SoloAgentsSection />
            <TeamLeadersSection />
            <TeamVARoles />
            <IndustryGrid />
            <SharedPain />

            <PageCTA
                headline="Sound Familiar?"
                sub="Let's talk about what your business actually needs. One conversation, no pressure."
                testId="who-we-serve-cta"
            />
        </div>
    );
}
